export let focusedRollupText = "OEw5oc";
export let otherRollupText = "X27Igd";
export default {focusedRollupText,otherRollupText};